import { PortalDialogProps } from "@app/services/modal.service";
import Modal from "../modal/modal.component";
import Input from "../input";
import Button from "../button";
import { Content, CreateContent } from "@app/types";
import { Form, Formik, FormikContextType } from "formik";
import { createRef, useEffect } from "react";
import { FormControl } from "../form-control";
import { createContentValidationSchema } from "@app/validations";

interface ContentModalProps {
  isEdit: boolean;

  content: Content;
}

function ContentModal({
  portalDialogRef,
  portalData,
}: PortalDialogProps<ContentModalProps>) {
  const formRef = createRef<FormikContextType<CreateContent>>();

  const onSubmit = (values: CreateContent) => {
    portalDialogRef.close({ content: values });
  };

  useEffect(() => {
    if (portalData?.content && formRef.current) {
      formRef.current.setValues({
        detectWord: portalData.content.detectWord,
        replaceWord: portalData.content.replaceWord,
      });
    }
  }, [portalData?.content]);

  return (
    <Modal onCancel={portalDialogRef.close}>
      <div className="w-[423px] py-7 px-6">
        <div className="text-black font-semibold text-xl">
          {portalData?.isEdit ? "Chỉnh sửa content" : "Thêm content"}
        </div>
        <Formik
          initialValues={{ detectWord: "", replaceWord: "" }}
          onSubmit={onSubmit}
          innerRef={formRef}
          validationSchema={createContentValidationSchema}
          validateOnChange
          validateOnBlur
        >
          <Form>
            <FormControl name="detectWord">
              <Input
                inputClassName="text-[#2C2D33]"
                className="mt-7"
                placeholder="Nhập detect word"
              />
            </FormControl>
            <FormControl name="replaceWord">
              <Input
                inputClassName="text-[#2C2D33]"
                className="mt-7"
                placeholder="Nhập replace word"
              />
            </FormControl>
            <div className="mt-11 flex justify-center gap-4">
              <Button
                size="xs"
                label="Hủy"
                theme="secondary"
                width={180}
                className="!h-[51px] !leading-[51px]"
                labelClassName="text-xl"
                onClick={portalDialogRef.close}
              />
              <Button
                type="submit"
                size="xs"
                label={portalData?.isEdit ? "Lưu" : "Thêm"}
                width={180}
                className="!h-[51px] !leading-[51px]"
                labelClassName="text-xl"
              />
            </div>
          </Form>
        </Formik>
      </div>
    </Modal>
  );
}

export default ContentModal;
